import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { publicAxios } from "../../api";

// export const joinSamoolahFunction = createAsyncThunk(
//   "join/joinSamoolahFunction",
//   async (data, { rejectWithValue }) => {
//     try {
//       const formData = new FormData();
//       // Object.keys(data).forEach((key) => {
//       //   if (key === "images" && Array.isArray(data[key])) {
//       //     data[key].forEach((image, index) => {
//       //       formData.append(`images[${index}]`, image);
//       //     });
//       //   } else {
//       //     formData.append(key, data[key]);
//       //   }
//       // });

//       Object.keys(formData).forEach((key) => {
//         if (key === "documents_images") {
//           formData.documents_images.forEach((file) => {
//             formData.append("documents_images", file);
//           });
//         } else if (key === "image" && formData[key]) {
//           formData.append("image", formData[key]);
//         } else if (key === "services" && Array.isArray(data[key])) {
//           formData.append("services", JSON.stringify(data[key]));
//         } else {
//           formData.append(key, formData[key]);
//         }
//       });

//       const response = await publicAxios.post(
//         "/api/ecomerce/regesiter",
//         formData,
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       return response.data;
//     } catch (error) {
//       if (error.response) {
//         console.error("Server Error:", error.response.data);
//         return rejectWithValue(error.response.data);
//       } else if (error.request) {
//         console.error("No response:", error.request);
//         return rejectWithValue(error.request);
//       } else {
//         console.error("Error:", error.message);
//         return rejectWithValue(error.message);
//       }
//     }
//   }
// );

export const joinSamoolahFunction = createAsyncThunk(
  "join/joinSamoolahFunction",
  async (data, { rejectWithValue }) => {
    try {
      const formData = new FormData();

      // Object.keys(data).forEach((key) => {
      //   if (key === "documents_images" && Array.isArray(data[key])) {
      //     data[key].forEach((file) => {
      //       formData.append("documents_images", file);
      //     });
      //   } else if (key === "image" && data[key]) {
      //     formData.append("image", data[key]);
      //   } else if (key === "services" && Array.isArray(data[key])) {
      //     formData.append("services", JSON.stringify(data[key]));
      //   } else {
      //     formData.append(key, data[key]);
      //   }
      // });

      Object.keys(data).forEach((key) => {
        if (key === "documents_images" && Array.isArray(data[key])) {
          data[key].forEach((file, index) => {
            formData.append(`documents_images[${index}]`, file);
          });
        } else if (key === "image" && data[key]) {
          formData.append("image", data[key]);
        } else if (key === "services" && Array.isArray(data[key])) {
          data[key].forEach((service) => {
            formData.append("services[]", parseInt(service));
          });
        } else if (key === "con_services" && Array.isArray(data[key])) {
          data[key].forEach((conservice) => {
            formData.append("con_services[]", parseInt(conservice));
          });
        } else {
          formData.append(key, data[key]);
        }
      });

      const response = await publicAxios.post(
        "/api/ecomerce/regesiter",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error("Server Error:", error.response.data);
        return rejectWithValue(error.response.data);
      } else if (error.request) {
        console.error("No response:", error.request);
        return rejectWithValue(error.request);
      } else {
        console.error("Error:", error.message);
        return rejectWithValue(error.message);
      }
    }
  }
);

const joinSamoolahSlice = createSlice({
  name: "joinSamoolah",
  initialState: {
    loadingForm: false,
    errorForm: null,
    successForm: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(joinSamoolahFunction.pending, (state) => {
        state.loadingForm = true;
        state.errorForm = null;
        state.successForm = false;
      })
      .addCase(joinSamoolahFunction.fulfilled, (state, action) => {
        state.loadingForm = false;
        state.successForm = true;
      })
      .addCase(joinSamoolahFunction.rejected, (state, action) => {
        state.loadingForm = false;

        if (action.payload && action.payload.status === false) {
          state.errorForm = "قيمة الهاتف مُستخدمة من قبل.";
        } else {
          state.errorForm = action.payload || "حدث خطأ غير متوقع.";
        }
      });
  },
});

export default joinSamoolahSlice.reducer;
